export enum PathVisibilityMode {
  ALL = 'ALL',
  WHITELIST = 'WHITELIST',
  BLACKLIST = 'BLACKLIST'
}

export const PATH_VISIBILITY_MODE_LABELS: Record<PathVisibilityMode, string> = {
  [PathVisibilityMode.ALL]: 'Show on all pages',
  [PathVisibilityMode.WHITELIST]: 'Show only on these pages',
  [PathVisibilityMode.BLACKLIST]: 'Hide on these pages'
};
